import {MaintenanceFormStatus} from "@/enums/MaintenanceFormStatus";
import { BaseModel } from '@/models/base/BaseModel';
import { MaintenanceMedia } from '@/models/maintenance/MaintenanceMedia';

export class MaintenanceForm extends BaseModel {
  locationId: string;
  status: string;
  formId: string;
  name: string;
  templateId: string;
  templateName: string;
  template: string;
  result: {};
  isMediaEnable: boolean
  media: MaintenanceMedia[]

  constructor(
    facilityId?: string,
    locationId?: string,
    status?: string,
    formId?: string,
    name?: string,
    templateId?: string,
    templateName?: string,
    template?: string,
    result?: object,
    isMediaEnable?: boolean,
    media?: MaintenanceMedia[]
  ) {
    super();
    this.facilityId = facilityId ?? null;
    this.locationId = locationId ?? null;
    this.status = status ?? MaintenanceFormStatus.InProgress;
    this.formId = formId ?? null;
    this.name = name ?? null;
    this.templateId = templateId ?? null;
    this.templateName = templateName ?? null;
    this.template = template ?? null;
    this.result = result ?? {};
    this.isMediaEnable = isMediaEnable ?? false;
    this.media = media ?? [];
  }

  toObject() {
    return {
      facilityId: this.facilityId,
      locationId: this.locationId,
      status: this.status,
      formId: this.formId,
      name: this.name,
      templateId: this.templateId,
      templateName: this.templateName,
      template: this.template,
      result: this.result,
      isMediaEnable: this.isMediaEnable,
      media: this.media
    };
  }
}